<template>
    <div id='product_list_container' class='container'>
            <!-- <div> -->
                <!-- <LockItInHeader/> -->
            <!-- </div> -->
            <!-- <div> -->
                <DynamicContent type='list_header' :content='dynamic_header_content' v-if='dynamic_header_content.page != null'/>
            <!-- </div> -->
            
            <ListHeader class='content-padding' :title='page_title' @sortListener='sortResults' @updatedFilterListener='updatedFilter' :filter_options='filter_options' :filter_data='filter_data' :filter_checkboxes_disabled='filter_checkboxes_disabled' :total_product_count='total_product_count' :show_recommended_sort='show_recommended_sort' :default_sort='sort' :default_filter_options_watcher='default_filter_options_watcher' :mobile_mode='mobile_mode' @showMobileFiltersListener='showMobileFilters' />
    
            <div v-show='loading' class='loading-container'>
                <Loading/>
            </div>

            <div v-show='!loading' class='content-padding'>
                <div v-if='products.length == 0 && pinned_products.length == 0'>
                    <div class='no-products-found-text'>No products found</div>
                </div>

                <div class='list-container'>
                    <Filters v-if='!mobile_mode' @updatedFilterListener='updatedFilter' :filter_options='filter_options' :filter_data='filter_data' :filter_checkboxes_disabled='filter_checkboxes_disabled' :default_filter_options_watcher='default_filter_options_watcher'/>
                    
                    <div class='products-container'>

                        <div v-for='product in pinned_products' :key="product" class='product'>
                            <ProductCard :product='product' :cart='cart' :is_amend='is_amend' @updatedCartListener='updatedCartListener' @cardClickedListener='saveFilters' @addToCartListener='addedToCart' @removedFromCartListener='removedFromCart' :total_cart_quantity='total_cart_quantity' @openProductInfoModalListener='openProductInfoModal'/>
                        </div>

                        <div v-for='product in products' :key="product" class='product'>
                            <ProductCard :product='product' :cart='cart' :is_amend='is_amend' @updatedCartListener='updatedCartListener' @cardClickedListener='saveFilters' @addToCartListener='addedToCart' @removedFromCartListener='removedFromCart' :total_cart_quantity='total_cart_quantity' @openProductInfoModalListener='openProductInfoModal'/>
                        </div>
                    
                        <div id='load_more_items'></div>
                    </div>
                </div>
            </div>

             <div>
                <DynamicContent type='list_footer' :content='dynamic_footer_content' v-if='dynamic_footer_content.page != null'/>
            </div>

            
        <SidePopOut id='product_filters_popout' :open_watcher='open_filters_watcher' :close_watcher='close_filters_watcher' v-if='mobile_mode'>
            <Filters v-if='mobile_mode' @updatedFilterListener='updatedFilter' :filter_options='filter_options' :filter_data='filter_data' :filter_checkboxes_disabled='filter_checkboxes_disabled' :default_filter_options_watcher='default_filter_options_watcher' :inside_popout='true' @closePopOutListener='closePopout' />
        </SidePopOut>

        <Modal modal_id='productDetailsModal' title='' size='xl'>
            <ProductDetailsModal :product_code='selected_product.code' :open_product_details_modal_watcher='open_product_details_modal_watcher' @closeProductDetailsListener='closeProductDetails' />
        </Modal>
    </div>
</template>

<script>
import Breadcrumbs from '@/ecom/components/products/Breadcrumbs.vue';
import Sort from '@/ecom/components/products/list/Sort.vue';
import ListHeader from '@/ecom/components/products/list/ListHeader.vue';
import Filters from '@/ecom/components/products/list/Filters.vue';
import ProductCard from '@/ecom/components/products/ProductCard.vue';

import Loading from '@/ecom/components/loading/Loading.vue';
import DynamicContent from '@/global/components/dynamic_pages/DynamicContent.vue';
import {checkAuth, setMetaTags, triggerPrerenderEvent, deepCopyObject, openModal, closeModal, checkOmetriaLoaded} from "@/global/modules/functions.js";
import SidePopOut from '@/ecom/components/overlays/SidePopOut.vue'
import {loadDynamicContent}  from "@/page_builder/builder/builder_tools/functions/pagebuilder_functions.js";
import Modal from "@/ecom/components/modals/Modal.vue";
import ProductDetailsModal from '@/ecom/components/products/ProductDetailsModal.vue';
export default {
    components: {Breadcrumbs, Sort, Filters, ProductCard, Loading, ListHeader, DynamicContent, SidePopOut, ProductDetailsModal, Modal},
    emits: ['updatedCartListener'],
    props: ['popstate_event', 'user_info'],
    props: ['popstate_event', 'user_info'],
    data(){
        return{
            products: [],
            number_of_results_per_batch: 24,
            current_index: 0,
            next_batch_of_products: [],
            observer: null,
            sort:{
                column: 'product.keyword',
                order: 'asc'
            },
            filters: {
                parent: '',
                subparent: '',
                category: '',
                product_filters: []
            },
            filter_options:[],
            filter_data:[],
            loading: true,
            filter_checkboxes_disabled: true,
            total_product_count: 0,
            search_string: '',
            page_title: '',
            custom_breadcrumbs: [],
            show_recommended_sort: false,
            dynamic_header_content: {
                page: null
            },
            dynamic_footer_content: {
                page: null
            },
            controller: null,
            page_number: 1,
            current_page: 1,
            pages: [],
            filters_from_url: [],
            default_filter_options_watcher: false,
            page_observer: null,
            page_number_from_load: 0,
            mobile_mode: false,
            screen_size_check_timeout: null,
            cart: [],
            total_cart_quantity: 0,
            open_filters_watcher: null,
            close_filters_watcher: null,
            cart_totals: {
                total_quantity: 0,
                total_before_discounts: 0,
                dicsounts: 0,
                total_with_discounts: 0
            },
            lock_it_in_data: {
                quantity: 0
            },
            is_amend : false,
            selected_product: {},
            open_product_details_modal_watcher: null,
            pinned_products: []
        }
    },
    methods:{
        openProductInfoModal(product){
            this.selected_product = product;
            this.open_product_details_modal_watcher = +new Date();
            openModal('productDetailsModal');
        },
        closeProductDetails(){
            closeModal('productDetailsModal');
        },
        showMobileFilters(){
            this.open_filters_watcher = +new Date();
        },
        async getProducts(initial_load = true, show_full_page_loading = false){
            if(show_full_page_loading){
                this.loading = true;
                // this.filters.product_filters.push({
                //     product_attribute_id: 0,
                //     attribute: 'instock',
                //     options: [true]
                // });
            }

            if (window.__PRERENDER_INJECTED){ //For prerender on prod build
                this.number_of_results_per_batch = 10000;
            }

            let fetch_next = this.number_of_results_per_batch;

            if(this.page_number_from_load != 0){
                fetch_next = this.number_of_results_per_batch * this.page_number_from_load;
                this.page_number = this.page_number_from_load;
                this.page_number_from_load = 0;
            }
            else{
                if(initial_load){
                    this.page_number = 1;
                }
            }
            
            this.next_batch_of_products = [];

            try{
                let response = await fetch(`/api/elastic-search/products?search_type=exact&start_index=${this.current_index}&fetch_next=${fetch_next}&sort_column=${this.sort.column}&sort_order=${this.sort.order}&filters=${encodeURIComponent(JSON.stringify(this.filters))}&route=${window.location.pathname}&search_string=${encodeURIComponent(this.search_string)}&filters_from_url=${JSON.stringify(this.filters_from_url)}&listing_type=lock_it_in&is_amend=${this.is_amend}&allow_pinned_products=true`, {
                    method: 'GET',
                    credentials: 'include',
                    signal: this.controller.signal
                });
    
                let results = await checkAuth(response);
                
                if (response.status === 200){
                    
                    if(initial_load){
                        // this.page_number = 1;

                        this.filters_from_url = [];
                        this.products = results.products;
                        this.pinned_products = results.pinned_products;

                        this.filter_options = results.filter_options;

                        this.filter_data = results.filter_data;


                        this.total_product_count = results.total_product_count;

                        // this.total_cart_quantity = results.total_cart_quantity;
              
                        // this.lock_it_in_data = results.lock_it_in_data;
    
                        if(results.products.length > 0){
                            this.current_index = this.number_of_results_per_batch;

                            if(results.products.length > this.number_of_results_per_batch){ //If loading more products than per page on initial load from back button
                                this.current_index = results.products.length;
                            }

                        } else {
                            this.loading = false;
                        }

                        this.handlePaginationSetup(true);
                    }
                    else{
                        this.page_number += 1;
                        results.products[0].page_number = this.page_number;

                        this.next_batch_of_products = results.products;
                        this.products = this.products.concat(this.next_batch_of_products);
                        this.current_index += this.number_of_results_per_batch;
    
                        this.handlePaginationSetup(false);
                    }

                    this.loading = false;
                    this.filter_checkboxes_disabled = false;
    
                    triggerPrerenderEvent();

                    setTimeout(() => {
                        this.default_filter_options_watcher = false;
                    }, 1000);
                }
            }
            catch(e){

            }
        },
        async getDynamicContent(){
            let path = this.$route.path;
            this.dynamic_header_content = await loadDynamicContent(path, 'list_header');
            this.dynamic_footer_content = await loadDynamicContent(path, 'list_footer');

            if(typeof this.dynamic_header_content === 'undefined'){
                this.dynamic_header_content = {
                    page: null
                }
            }
            if(typeof this.dynamic_footer_content === 'undefined'){
                this.dynamic_footer_content = {
                    page: null
                }
            }
        },
        setPageTitle(title){
            if(this.search_string == ''){
                this.page_title = title;
            }
        },
        sortResults(sort_column, sort_order){
            this.sort = {
                column: sort_column,
                order: sort_order
            }
            this.current_index = 0;
            this.formatFilterParams();
            this.getProducts(true);
        },
        updatedFilter(selected_filters){
            this.filters.product_filters = selected_filters;
            this.formatFilterParams();
            this.resetProducts();
        },
        formatFilterParams(){


            let query_params = "?";

            for (let i = 0; i < this.filters.product_filters.length; i++) {
                let filter = this.filters.product_filters[i];

                if(i != 0){
                    query_params += '&';
                }

                query_params += `${encodeURIComponent(filter.attribute)}=`;

                for (let j = 0; j < filter.options.length; j++) {
                    let option = filter.options[j];      

                    if(j != 0){
                        query_params+= "|";
                    }
                    if(filter.attribute == 'price'){
                        let price_filter = `${option.min_price};${option.max_price}`;
                        query_params += encodeURIComponent(price_filter);
                    }
                    else{
                        query_params += encodeURIComponent(option);
                    } 
                }

            }

            if(this.search_string != ''){
                query_params += `&q=${encodeURIComponent(this.search_string)}`
            }
            
            let sort_column = this.sort.column;

            if(sort_column != 'recommended'){

                switch(this.sort.column){
                    case 'product.keyword': 
                        sort_column = 'alphabetical'
                    break;
                }

                query_params += `&sortby=${sort_column}_${this.sort.order}`
            }
            else{
                query_params += `&sortby=recommended`;
            }

            query_params += `&page=${this.current_page}`;

            // history.pushState({id: `${window.location.pathname}${query_params}`}, null, `${window.location.pathname}${query_params}`); //Change url and history stack without router.push
        },
        resetProducts(){
            this.current_index = 0;
            this.getProducts(true);
        },
        detectEndOfResults(entries, opts){
            entries.forEach(entry =>{
                if(entry.isIntersecting == true){
                    this.getProducts(false);
                }
            });
        },
        detectPageChangeOnScroll(entries, opts){
            entries.forEach(entry =>{
                if(entry.isIntersecting == true){
                    this.current_page = entry.target.id.split('page_number_')[1];
                    this.formatFilterParams();
                }
            });
        },
        setupPageScrollObserver(page_number){

            this.page_observer =  new IntersectionObserver(this.detectPageChangeOnScroll, {
                root: null,  
                threshold: .5 
            }); 

            this.page_observer.observe(document.getElementById(`page_number_${page_number}`));

        },
        destroyInfiniteLoad(){
            this.observer.unobserve(document.getElementById('load_more_items'));
        },
        updatedCartListener(){
            this.$emit('updatedCartListener');
        },
        async getCategoryMetaTags() {
            let response = await fetch(`/api/meta-tags/category?route=${window.location.pathname}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);

            if (response.status === 200){
                if(results){
                    const canonical_url = window.location.origin + this.$route.path;
                    setMetaTags(results.title_tag, results.description_tag, results.keywords_tag, canonical_url);
                }
            }
        },
        saveFilters(){
            let save_data = {
                filters: this.filters.product_filters
            }

            localStorage.setItem('product_list_filters', JSON.stringify(save_data));
            this.cached_products = this.products;
        },
        loadFilters(){
            let saved_data = JSON.parse(window.localStorage.getItem("product_list_filters"));

            this.filters.product_filters = saved_data.filters;
        },
        getFiltersFromUrl(params){
            for(const [ key, value ] of params){
                if(key !== 'sortby' && key != 'instock' && key != 'q' && key != 'page' && key != 'is_amend'){
                    
                    let options = null;

                    if(key != 'price'){
                        options = value.split('|');
                    }
                    else{
                        let prices = value.split(';');
                        this.filter_data.prices = {
                            min_price: prices[0],
                            max_price: prices[1],
                        }

                        options =  [this.filter_data.prices];
                    }

                    let filter_object = {
                        attribute: key,
                        product_attribute_id: '',
                        options: options
                    }

                    this.filters_from_url.push(filter_object);
            
            
                }

                if(key == 'sortby'){
                    let sort_array = value.split('_');
                    let sort_column = sort_array[0];

                    if(sort_column == 'alphabetical'){
                        sort_column = 'product.keyword'
                    }

                    this.sort = {
                        column: sort_column,
                        order: sort_array[1] ?? 'asc'
                    }
                    
                }

                if(key == 'page'){
                    this.page_number_from_load = value;
                    console.log('page number form load', value);
                }
            }

            this.filters.product_filters = deepCopyObject(this.filters_from_url);

            this.default_filter_options_watcher = true;
        },
        setupMultiPageScroller(){
            for (let i = 0; i < this.page_number; i++) {
                this.setupPageScrollObserver(i+1);
            }
        },
        handlePaginationSetup(initial_load){
            if(initial_load){
                this.page_number = 1;
                 this.products[0].page_number = this.page_number;
 
                 if(this.products.length > this.number_of_results_per_batch){ //If loading more products than per page, setup each page
 
                     for (let i = 0; i < this.products.length; i++) {
                         if(i % this.number_of_results_per_batch == 0 && i != 0){ //e.g. if loading 40 products and there are 10 per page, setup page 1 = 0-10, page 2 = 11-20, page 3 = 21-30, page 4 = 31-40;
                             this.page_number += 1;
                             this.products[i].page_number = this.page_number;
                         }
                     }
                     setTimeout(() => {
                         this.setupMultiPageScroller(); //setup an observer for each page
                     }, 100);
                 }
                 else{
                     setTimeout(() => {
                         this.setupPageScrollObserver(this.page_number); //If on 1 page on initial setup, set up 1 observer to begin with
                     }, 100);
                 }
            }
            else{
                setTimeout(() => {
                    this.setupPageScrollObserver(this.page_number); //setup observer for any additional pages as scrolling down;
                }, 100);
            }
        },
        checkMobileMode(){
            let element = document.getElementById('product_list_container');

            if(typeof element !== 'undefined'){
                new ResizeObserver(()=>{
                    clearTimeout(this.screen_size_check_timeout);

                    this.screen_size_check_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error
                        if(element.clientWidth <= 768){
                            this.mobile_mode = true;
                        }
                        else{
                            this.mobile_mode = false;
                        }
                        
                    }, 1);
                }).observe(element);
            }
        },
        addedToCart(product, quantity){
            let added_product = this.products.filter(x=>x.code == product.code)[0];

            if(typeof added_product == 'undefined'){
                added_product = this.pinned_products.filter(x=>x.code == product.code)[0];
            }
            added_product.locked_in = true;
            this.getTotalCartItems();
        },
        removedFromCart(product, quantity){
            let removed_product = this.products.filter(x=>x.code == product.code)[0];

            if(typeof removed_product == 'undefined'){
                removed_product = this.pinned_products.filter(x=>x.code == product.code)[0];
            }

            removed_product.locked_in = false;
            this.getTotalCartItems();
        },
        async getTotalCartItems(){
            let response = await fetch(`/api/lock-it-in/cart-totals?is_amend=${this.is_amend}`, {
                method: 'GET'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.total_cart_quantity = results;
                this.cart_totals = results;
            }
        },
        async getLockItInData(){
            let response = await fetch(`/api/lock-it-in/data?is_amend=${this.is_amend}`, {
                method: 'GET'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.lock_it_in_data = results;
            }
        },
        closePopout(){
            this.close_filters_watcher = +new Date();
        },
        infiniteLoadSetup(){
            this.observer = new IntersectionObserver(entries => {
                entries.forEach(entry =>{
                    if(entry.isIntersecting == true){
                        this.getProducts(false);
                    }
                });
            });

            this.observer.observe(document.getElementById('load_more_items'));
        }
    },
    created(){
        this.getDynamicContent();
    },
    beforeRouteUpdate(){

    },
    mounted() {
        this.is_amend = (this.$route.query.is_amend) ? true : false;
        this.controller = new AbortController();
        this.getDynamicContent();
        this.checkMobileMode();
        this.getTotalCartItems();
        this.getLockItInData();

        let params = this.$route.params;

        this.filters.parent = params.parent;
        this.filters.subparent = params.subparent;
        this.filters.category = params.category;
        const urlParams = new URLSearchParams(window.location.search);
        this.search_string = urlParams.get('q') ?? '';

        this.getFiltersFromUrl(urlParams);

        if(this.search_string != ''){

            let title_tag = `Results for ${this.search_string}`;

            setMetaTags(title_tag, title_tag, '');

            this.custom_breadcrumbs = [
                {id: 1, name: 'Search Results'}
            ]
            this.page_title = `Search results for '${this.search_string}'`;

            this.sort.column = 'recommended';
        } 
        else{
            this.getCategoryMetaTags();
        }

        this.getProducts(true, true);
        this.infiniteLoadSetup();
        
        if(checkOmetriaLoaded()) {
            ometria.init('listing', null, '501');
            if(this.user_info && this.user_info.Email) ometria.identify(this.user_info.Email); 
        }
    },
    watch:{
        'popstate_event': function(){
            // if(typeof this.popstate_event.state.id !== 'undefined'){
            // if(typeof this.popstate_event.state.id !== 'undefined'){
                
            //     /* popstate event triggers after mounted, so need to cancel the original mounted call and replace with new api call */
            //     this.controller.abort();
            //     this.controller = new AbortController(); //Create new abort controller as cannot reset or destory old one;
            //     /* popstate event triggers after mounted, so need to cancel the original mounted call and replace with new api call */
            //     this.controller.abort();
            //     this.controller = new AbortController(); //Create new abort controller as cannot reset or destory old one;

            //     history.replaceState({},null,`${this.popstate_event.state.id}`); //Change url to what was stored in the history stack data
            //     const urlParams = new URLSearchParams(window.location.search); //Get filter params from new url
            //     this.getFiltersFromUrl(urlParams);
            //     this.getProducts(true, true);
            // }
        },
        $route(to, from) {
         
        }
    }

}
</script>

<style lang="scss" scoped>
.container{
    display:flex;
    flex-direction: column;
    gap: 30px;
    padding-top: 24px;
    // padding-bottom: 50px;
    
    // padding-left: 150px;
    // padding-right: 150px;
    // padding-top: 20px;

    // @media (max-width: 1700px) {
    //     padding-right: 100px;
    //     padding-left: 100px;
    // }

    // @media (max-width: 1600px) {
    //     padding-right: 20px;
    //     padding-left: 20px;
    // }
}

.list-container{
    display: flex;
    gap: 28px;
}

.content-padding{
    padding-left: 200px;
    padding-right: 200px;
    
        @media (max-width: 1700px) {
        padding-right: 100px;
        padding-left: 100px;
    }

    @media (max-width: 1600px) {
        padding-right: 20px;
        padding-left: 20px;
    }
}


.filters-container{
    // flex: 1;

    @media(max-width: 1300px){
        display: none;
    }
}

// .list-container{
    // display:flex;
    // gap: 30px;
    // margin-top: 40px;
    // flex-wrap: wrap;
    // align-items: flex-start;
// }

// .products-container{ //List with flex
//     display: flex;
//     flex-wrap: wrap;
//     gap: 20px;
//     flex: 5;
// }

.products-container{ //List with grid
    display: grid;
    width: 100%;

    // grid-template-columns: repeat(auto-fill, minmax(var(--product-card-width),1fr));
    // grid-template-columns: repeat(2, minmax(var(--product-card-width),1fr));
    grid-template-columns: repeat(2, 1fr);
    align-items: stretch;
    row-gap: 40px;
    column-gap: 10px;

    justify-items: center;
     @media(max-width: 936px){
        grid-template-columns: repeat(1, 1fr);
    }
}

// .products-container{ //List with grid
//     display: grid;
//     // grid-template-columns: repeat(2, 1fr);
//         grid-template-columns: repeat(auto-fill, minmax(var(--product-card-width),1fr));
//     align-items: stretch;
//     row-gap: 40px;
//     column-gap: 10px;
//     grid-auto-rows: 1fr; //All same height

//     @media(max-width: 936px){
//         grid-template-columns: repeat(1, 1fr);
//     }
// }

.product{ //Make all cards same height
    display: flex;
    align-self: stretch; 
}

.loading-container{
    width: 75px;
    height: 75px;
    margin: auto;
    margin-top: 50px;
}

.no-products-found-text{
    font-size: 1.8rem;
    text-align: center;
    color: var(--medium-cool-grey);

}
.list-breadcrumbs{
    margin-top: 34px;
}
</style>